var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0863 19.8C13.0863 20.3835 12.8489 20.9431 12.4264 21.3556C12.0039 21.7682 11.4308 22 10.8332 22C10.2357 22 9.66259 21.7682 9.24005 21.3556C8.81752 20.9431 8.58014 20.3835 8.58014 19.8H13.0863ZM10.8332 0C11.132 0 11.4185 0.115892 11.6298 0.322182C11.8411 0.528473 11.9598 0.808262 11.9598 1.1V2.288C15.1592 2.816 17.5925 5.533 17.5925 8.8V15.4L20.9721 18.7H0.694336L4.07397 15.4V8.8C4.07397 5.533 6.5073 2.816 9.70668 2.288V1.1C9.70668 0.808262 9.82537 0.528473 10.0366 0.322182C10.2479 0.115892 10.5344 0 10.8332 0V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8473 7H9.8195V10L6.77783 10V12H9.8195V15H11.8473V12H14.889V10L11.8473 10V7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notificationBell.7176505eb1e39b1c9343c9ae25918d1e.svg";
export { ForwardRef as ReactComponent };